<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader title="Quality Review"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px">
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Role" prop="role">
            <el-select v-model="form.role" placeholder="Please select Role" filterable @change="roleChange">
              <el-option v-for="(item, idx) in roleOptions" :key="idx" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Leader" prop="taId">
            <el-select v-model="form.taId" placeholder="Please select Leader" filterable @change="taChange">
              <el-option v-for="(item, idx) in taOptions" :key="idx" :label="item.TAName" :value="item.TAID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Team">
            <el-select v-model="form.teamId" placeholder="Please select Team" @change="teamChange" filterable>
              <el-option v-for="(item, idx) in teamOptions" :key="idx" :label="item.TeamName" :value="item.TeamID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="User">
            <el-select v-model="form.mlId" placeholder="Please select User" @change="mlChange" filterable>
              <el-option v-for="(item, idx) in mlListOptions" :key="idx" :label="item.MLName" :value="item.MLID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label-width="labelWidth" :label="nameLabel">
            <el-select class="se-select" v-model="form.seId" multiple collapse-tags
              @change="seOrMonthSelectChange($event, 'seId')" :placeholder="`Please select ${nameLabel}`" filterable>
              <el-option-group v-for="(group, i) in seListOptions" :key="i" :label="group.MLName">
                <el-option v-for="(item, j) in group.SE" :key="j" :label="item.SEName" :value="item.SEID">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="shouldShowColumn">
          <el-form-item label="HCP Type" prop="hcpType" label-width="100px">
            <el-select v-model="form.hcpType" placeholder="Please select type">
              <el-option label="All" value="" />
              <el-option
                label="SE"
                value="SE"
              />
              <el-option label="CE" value="CE" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Type">
            <el-select v-model="form.type" placeholder="Please select Type" @change="typeChange">
              <el-option v-for="item in typeOptions" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Status">
            <el-select v-model="form.status" placeholder="Please select Status" :disabled="form.type != 2">
              <el-option v-for="item in statusOptions" :key="item.ParamID" :label="item.ParamValue"
                :value="item.ParamID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option v-for="item in yearsOptions" :key="item.Year" :label="item.Year" :value="item.Year">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label-width="labelWidth" label="Month">
            <el-select class="monthSelect" ref="monthSelect" v-model="form.month" placeholder="Please select month"
              multiple v-multiple-tip @change="seOrMonthSelectChange($event, 'month')">
              <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button type="primary" icon="el-icon-search" @click="getTableData()" :disabled="queryable">
            Query
          </el-button>
          <el-button class="right-export-btn" type="primary" icon="iconfont icon-export" @click="getTableData(true)"
            :disabled="exportable" :loading="exporting">
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading...">
        <el-table-column prop="MLName" label="User" width="120" />
        <el-table-column prop="TaConfigName" label="TA" min-width="130" />
        <el-table-column prop="SEName" :label="nameLabel" min-width="90" />
        <el-table-column prop="TypeDescription" label="HCP Type" min-width="80" v-if="shouldShowColumn" />
        <el-table-column prop="RequestType" label="Request Type" min-width="160" />
        <el-table-column min-width="145" prop="RequestContent" label="Request Content">
          <template slot-scope="{ row }">
            <template v-if="row.RequestContent.length < 25">
              {{ row.RequestContent }}
            </template>
            <el-popover v-else placement="top-start" width="300" trigger="hover" :content="row.RequestContent"
              popper-class="request-content-popover">
              <div slot="reference" class="request-content-wrapper">
                {{ `${row.RequestContent.substring(0, 25)}...` }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="FullfillmentDate" label="Fulfillment Date" />

        <el-table-column label="Fulfillment Description" min-width="185" prop="FullfillmentDesc">
          <template slot-scope="{ row }">
            <div v-html="row.FullfillmentDesc"></div>
          </template>
        </el-table-column>
        <el-table-column label="Meeting Title" min-width="120" prop="MeetingTitle" />
        <el-table-column min-width="130" prop="MeetingStatus" label="Meeting Status" />
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import downloadjs from "downloadjs";
import labelMixin from "@/mixins/label-mixin";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "Quality-Review",
  mixins: [labelMixin],
  data() {
    return {
      tableLoading: false,
      tableData: [],
      exporting: false,
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        mlId: "",
        seId: [],
        type: "",
        status: "",
        hcpType:''
      },
      value: "",
      roleList: [],
      taList: [],
      teamList: [],
      mlList: [],
      seList: [],
      otherList: null,
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      queryable: true,
      exportable: true,
    };
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
    this.form.seId.push("");
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    labelWidth() {
      return this.nameLabel === "SE/CE" ? "60px" : "80px";
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    mlName() {
      let ml = this.mlListOptions.find((item) => item.MLID === this.form.mlId);
      return ml ? ml.MLName : "";
    },
    seName() {
      let allSEList = Array.from(this.seList, (item) => item.SE);
      allSEList = [].concat.apply([], allSEList);
      let seNames = Array.from(this.form.seId, (seId) => {
        let se = allSEList.find((j) => j.SEID === seId);
        return se ? se.SEName : "";
      });
      return seNames.toString();
    },
    type() {
      let type = this.typeOptions.find((item) => item.key === this.form.type);
      return type ? type.value : "All";
    },
    status() {
      let status = this.statusOptions.find(
        (item) => item.ParamID === this.form.status
      );
      return status ? status.ParamValue : "";
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    typeOptions() {
      return this.otherList ? this.otherList.type : [];
    },
    statusOptions() {
      return this.otherList ? this.otherList.status : [];
    },
    mlListOptions() {
      return this.mlList.filter((i) => {
        return (
          (this.form.teamId != ""
            ? i.TeamID === this.form.teamId
            : this.teamOptions.some((j) => j.TeamID === i.TeamID)) ||
          i.MLName === "All"
        );
      });
    },
    seListOptions() {
      return this.seList.filter((i) => {
        return (
          (this.form.mlId !== ""
            ? i.MLID === this.form.mlId
            : this.mlListOptions.some((j) => j.MLID === i.MLID)) ||
          i.MLName === "All"
        );
      });
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
        this.taList.filter(({ RoleName }) => {
          return this.form.role ? this.form.role === "MSL" ? RoleName === "TALead" : RoleName.indexOf(this.form.role) > -1 : true;
        })
      );
    },
    teamOptions() {
      let options = this.teamList.filter(({ TAID, RoleName }) => {
        return this.form.taId ? this.form.taId === TAID
          : (RoleName.indexOf(this.form.role) > -1 || (this.form.role === "MSL" && (RoleName === "TALead" || RoleName === "Supervisor")))
      });
      return this.role === 1 || this.role === 4 ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options) : options;
    },
    shouldShowColumn() {
      // Admin, Supervisor, ML, VMSL
      return [1,2,3,13].includes(this.$store.state.role);
    }
  },
  methods: {
    typeChange(value) {
      console.log('---', value)
      if (value != 2) {
        this.form.status = ''
      }
    },
    roleChange() {
      this.form.taId = "";
      this.taChange();
    },
    taChange() {
      this.form.teamId = "";
      this.form.mlId = "";
      this.form.seId = [""];
    },
    teamChange() {
      this.form.mlId = "";
      this.form.seId = [""];
    },
    mlChange() {
      this.form.seId = [""];
    },
    seOrMonthSelectChange(value, key) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form[key] = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form[key] = [""];
      }
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get(`analytics/otherList`),
        this.axios.get("analytics/mlList"),
        this.axios.get("analytics/seList"),
        this.axios.get(`analytics/roleList`),
      ]).then((res) => {
        this.getTAList(res[0]);
        this.getTeamList(res[1]);
        this.getOtherList(res[2]);
        this.getMlList(res[3]);
        this.getSEList(res[4]);
        this.getRoleList(res[5]);
        this.getTableData();
        this.queryable = false;
        this.exportable = false;
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (this.role === RoleCode.Supervisor || this.role === RoleCode.TALead) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(({ value }) => roleName.indexOf(value) > -1) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        this.taList = data;
        if (this.role === 4) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (this.role == RoleCode.Supervisor
          || this.role == RoleCode.CRPLeader
          || this.role == RoleCode.CVEOLeader
          || this.role == RoleCode.SciComLeader
          || this.role == RoleCode.ClinTransLeader) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
        this.otherList.type.unshift({ key: "", value: "All" });
        this.otherList.status.unshift({ ParamID: "", ParamValue: "All" });
      } else {
        this.$message.error(msg);
      }
    },
    getMlList({ code, data, msg }) {
      if (200 === code) {
        this.mlList = [
          {
            MLName: "All",
            MLID: "",
            TeamID: "",
          },
        ].concat(data);
      } else {
        this.$message.error(msg);
      }
    },
    getSEList({ code, data, msg }) {
      if (200 === code) {
        this.seList = data;
        for (var i = 0; i < this.seList.length; i++) {
          if (this.seList[i].SE.length == 0) {
            this.seList.splice(i, 1);
          }
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      let seId = "";
      if (this.form.seId.length > 0 && this.form.seId.indexOf("") === -1) {
        seId = this.form.seId.toString();
      }
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        seId: seId,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
          mlName: this.mlName,
          seName: this.seName,
          typeName: this.type,
          statusName: this.status,
        });
      }
      this.axios
        .get("analytics/qualityReview", {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            this.tableLoading = false;
            if (200 === code) {
              this.tableData = data;
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;

  .el-form-item {
    margin-bottom: 10px !important;

    .el-select {
      width: 100%;
    }
  }

  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}

.request-content-popover {
  background-color: red;
}
</style>
